<template>
  <div>
    <Assistant_teacher_bar />
    <!-- Dashboard Header -->
    <v-container fluid class="pa-0">
      <div class="dashboard-header">
        <v-row class="ma-0">
          <v-col cols="12" class="text-center py-8">
            <h1 class="font-weight-bold white--text mb-4">
              รายงานสรุปผลคะแนนการประเมิน ตำแหน่งครูผู้ช่วย
            </h1>
            <p class="white--text opacity-80">
              ระบบติดตามและประเมินผลการปฏิบัติงานครูผู้ช่วย ครั้งที่ 1 - 4
            </p>
          </v-col>
        </v-row>
      </div>
    </v-container>

    <v-container fluid class="main-content">
      <!-- Statistics Cards -->
      <v-row class="mb-6">
        <v-col
          cols="12"
          md="3"
          v-for="(stat, index) in statisticsCards"
          :key="index"
        >
          <v-card class="stat-card elevation-3" :class="stat.color" hover>
            <v-card-text class="text-center py-6">
              <v-icon :color="stat.iconColor" size="48" class="mb-3">
                {{ stat.icon }}
              </v-icon>
              <div class="stat-number font-weight-bold mb-2">
                {{ stat.value }}
              </div>
              <div class="stat-label font-weight-medium">
                {{ stat.label }}
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Filters Section -->
      <base-material-card
        icon="mdi-filter-variant"
        title="เครื่องมือค้นหาและกรอง"
        class="filter-card elevation-3 mb-6"
      >
        <v-card class="filter-content" outlined>
          <v-row no-gutters>
            <v-col cols="12" md="4" class="pa-3">
              <v-autocomplete
                outlined
                dense
                label="ค้นหา วิทยาลัย"
                :items="colleges"
                item-text="college_name"
                item-value="college_code"
                v-model="college_select"
                @change="assistant_teacher_reportCollegeQueryAll()"
                prepend-inner-icon="mdi-school"
                hide-details
                class="custom-input"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" class="pa-3">
              <v-autocomplete
                outlined
                dense
                label="วันเดือนปีที่บรรจุ"
                :items="groupDateTimeApps"
                item-text="dateApps"
                item-value="dateApps"
                @change="personnel_temporaryDateApp()"
                v-model="dateTimeAppSelect"
                prepend-inner-icon="mdi-calendar"
                hide-details
                class="custom-input"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              md="4"
              class="pa-3 d-flex align-center justify-end"
            >
              <v-btn
                fab
                outlined
                class="mr-2 custom-btn"
                color="primary"
                :href="'#/admin/print_AssismentReportCP/'"
                target="_blank"
                elevation="2"
              >
                <v-icon>mdi-printer</v-icon>
              </v-btn>

              <v-btn
                fab
                outlined
                :href="
                  '#/admin/print_AssismentReportCPDay2/?mt_appoin_day=' +
                    mt_appoin_day +
                    '&mt_appoin_month=' +
                    mt_appoin_month +
                    '&mt_appoin_year=' +
                    mt_appoin_year +
                    '&mt_type_personnel=' +
                    (mt_type_personnel || 0) +
                    '&mt_admissions_status=' +
                    (mt_admissions_status || 0)
                "
                target="_blank"
                color="info"
                class="mr-2 custom-btn"
                v-if="check_param_query > 1"
                elevation="2"
              >
                <v-icon>mdi-printer-search</v-icon>
              </v-btn>

              <v-btn
                fab
                color="primary"
                @click="checkappoint()"
                class="custom-btn"
                elevation="2"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </base-material-card>

      <!-- Alert Section -->
      <div class="text-center ma-4" v-if="check_CC.counts > 0">
        <v-alert
          type="warning"
          prominent
          border="left"
          colored-border
          class="alert-custom"
        >
          <v-row align="center">
            <v-col class="grow">
              <div class="title font-weight-bold">
                ยกเลิกไฟล์สรุปวันลา: {{ check_CC.counts }} รายการ
              </div>
            </v-col>
            <v-col class="shrink">
              <v-btn @click="ccSearch()" color="error" large class="custom-btn">
                <v-icon left>mdi-alert</v-icon>
                ดูรายละเอียด
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </div>
    </v-container>

    <!-- Loading Overlay -->
    <v-overlay :value="loading" z-index="9999">
      <v-progress-circular
        indeterminate
        size="64"
        color="primary"
      ></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      top
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      elevation="6"
    >
      <v-icon large class="mr-3">{{ snackbar.icon }}</v-icon>
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

    <v-container fluid>
      <base-material-card
        icon="mdi-clipboard-text"
        title="รายงานสรุปผลคะแนนการประเมิน ตำแหน่งครูผู้ช่วย ครั้งที่ 1 - 4"
        class="table-card elevation-3"
      >
        <v-card elevation="0" outlined>
          <v-card-title
            ><v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="mr-2"
              @click="importCsvDialog = true"
              dark
            >
              <v-icon left>mdi-file-upload</v-icon> นำเข้า CSV อนุมัติ คศ.1
            </v-btn>

            <v-btn color="success" @click="approveTeach()"
              >ประกาศ ให้ดำรงตำแหน่ง ครู ทั้งหมด</v-btn
            ></v-card-title
          >
        </v-card>
        <v-data-table
          :headers="headers"
          :items="assistant_teacher_reports"
          class="custom-table elevation-0"
          :loading="loading"
          :search="search"
          :items-per-page="25"
          loading-text="กำลังโหลดข้อมูล..."
          no-data-text="ไม่พบข้อมูล"
        >
          <template v-slot:top>
            <div class="search-section pa-4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
                filled
                dense
                hide-details
                class="search-input mb-4"
                clearable
              />

              <v-radio-group row class="search-options">
                <v-radio
                  label="ชื่อ"
                  value="radio-1"
                  @click.native="search_name()"
                  color="primary"
                ></v-radio>
                <v-radio
                  label="นามสกุล"
                  value="radio-2"
                  @click.native="search_lastname()"
                  color="primary"
                ></v-radio>
                <v-radio
                  label="รหัสบัตรประชาชน"
                  value="radio-3"
                  @click.native="search_idcard()"
                  color="primary"
                ></v-radio>
              </v-radio-group>
            </div>
          </template>

          <template v-slot:item.LoginAdmin="{ item }">
            <v-icon
              v-if="user_id.userauthorityAdmin === '1' || user_id.userauthorityAdmin === 1"
              color="info"
              @click="userLogin(item.user_name, item.user_password)"
            >
              mdi-puzzle
            </v-icon>
          </template>

          <template v-slot:item.mt_type_personnel="{ item }">
            <div v-if="item.mt_type_personnel === 'local_dev'">
              <v-chip color="info" dark>ครูพัฒนาท้องถิ่น</v-chip>
            </div>
            <div v-else-if="item.mt_type_personnel === 'transfer_position'">
              <v-chip color="warning" dark>ครูโอนย้าย</v-chip>
            </div>
            <div v-else>
              <v-chip color="success" dark>ปกติ</v-chip>
            </div>
          </template>

          <template v-slot:item.pt_licence="{ item }">
            <div v-if="item.mt_license_status === 'have' || item.mt_license_status === 'Have' || item.mt_license_status === 'HAVE' ">
              <v-icon color="info" size="30"
                >mdi-card-account-details-star</v-icon
              >
            </div>

            <div v-else-if="item.mt_license_status === 'donot'">
              (P License)
              <v-icon color="warning" size="30">mdi-card-bulleted-off</v-icon>

              <div v-if="item.pt_licence_tem">
                <div v-if="String(item.pt_licence_file_tem).length < 10">
                  <v-chip color="error" outlined>
                    <v-icon>mdi-alert</v-icon> ไม่ได้แนบไฟล์
                  </v-chip>
                </div>
                <div v-else>
                  <v-chip
                    @click="viewpdflicenseteach(item.pt_licence_file_tem)"
                    outlined
                    color="info"
                  >
                    <v-icon>mdi-magnify</v-icon>
                    {{ item.pt_licence_tem }}</v-chip
                  >
                </div>
                หมดอายุวันที่ <br />
                {{
                  item.pt_enddate_tem
                    | moment("add", "543 year")
                    | moment("D MMMM YYYY")
                }}
                <div
                  v-if="item.datediffendtem <= 0"
                  class="error--text font-weight-bold"
                >
                  <v-icon color="error" size="30">mdi-alert</v-icon>
                  <br />
                  หมดก่อน {{ item.datediffendtem }} วัน
                </div>

                <v-btn
                  icon
                  @click="updateLicense(item.mt_id)"
                  color="grey"
                  dark
                >
                  <v-icon>mdi-magnify-close</v-icon>
                </v-btn>
              </div>
              <div v-else>
                <v-chip color="error" outlined>
                  <v-icon>mdi-alert</v-icon> ไม่ได้แนบไฟล์
                </v-chip>
              </div>
            </div>

            <div
              v-else-if="item.mt_license_status === 'waitpl'"
              class="error--text"
            >
              ขอ (P License) <br />
              <v-icon color="error" size="30">mdi-card-bulleted-off</v-icon>
            </div>

            <div
              v-else-if="item.mt_license_status === 'anything'"
              class="warning--text"
            >
              (P License) <br />
              <v-icon color="error" size="30">mdi-card-bulleted-off</v-icon>
            </div>

            <div v-if="item.pt_licence_file_ipa === 'pass'">
              <v-icon color="success">mdi-check-circle</v-icon>
            </div>

            <div
              v-else-if="item.pt_licence_file_ipa === 'dontpass'"
              class="error--text"
            >
              {{ item.pt_licence_file_ipacomment }}
            </div>

            <div v-if="item.pt_licence">
              <div v-if="String(item.pt_licence_file).length < 10">
                <v-chip color="error" outlined>
                  <v-icon>mdi-alert</v-icon> ไม่ได้แนบไฟล์
                </v-chip>
              </div>
              <div v-else>
                <v-chip
                  @click="viewpdflicenseteach(item.pt_licence_file)"
                  outlined
                  color="info"
                >
                  <v-icon>mdi-magnify</v-icon>
                  {{ item.pt_licence }}</v-chip
                >
              </div>
              หมดอายุวันที่ <br />
              {{
                item.pt_enddate
                  | moment("add", "543 year")
                  | moment("D MMMM YYYY")
              }}
              <div
                v-if="item.datediffend <= 0"
                class="error--text font-weight-bold"
              >
                <v-icon color="error" size="30">mdi-alert</v-icon> <br />
                หมดก่อน {{ item.datediffend }} วัน
              </div>

              <br />
              <v-btn icon @click="updateLicense(item.mt_id)" color="grey" dark>
                <v-icon>mdi-magnify-close</v-icon>
              </v-btn>
            </div>
          </template>

          <template v-slot:item.approve_level1="{ item }">
            <div>
              <v-btn @click="approveTeach_id(item)" color="success" rounded
                >อนุมัติ</v-btn
              >
            </div>
          </template>
          <template v-slot:item.pt_licence_ict="{ item }">
            <v-icon color="success" v-if="item.pt_licence_ict === 'ict'"
              >mdi-check-circle</v-icon
            >
            <v-icon color="error" v-else>mdi-close</v-icon>
          </template>

          <template v-slot:item.mt_time_1_score="{ item }">
            <div v-if="item.mt_time_1_ck === 'Pass'">
              <v-btn color="success" icon small>
                <v-icon>mdi-check-circle</v-icon>
              </v-btn>
            </div>

            <v-chip
              v-if="item.mt_time_1_score > 0"
              color="info"
              @click="viewFileScore((param = item.mt_time_1_file))"
            >
              <span class="font-weight-bold warning--text">{{
                item.mt_time_1_score
              }}</span>
            </v-chip>
          </template>

          <template v-slot:item.mt_time_2_score="{ item }">
            <div v-if="item.mt_time_2_ck === 'Pass'">
              <v-btn color="success" icon small>
                <v-icon>mdi-check-circle</v-icon>
              </v-btn>
            </div>

            <v-chip
              v-if="item.mt_time_2_score > 0"
              color="info"
              @click="viewFileScore((param = item.mt_time_2_file))"
            >
              <span class="font-weight-bold warning--text">{{
                item.mt_time_2_score
              }}</span>
            </v-chip>
          </template>

          <template v-slot:item.mt_time_3_score="{ item }">
            <div v-if="item.mt_time_3_ck === 'Pass'">
              <v-btn color="success" icon small>
                <v-icon>mdi-check-circle</v-icon>
              </v-btn>
            </div>
            <v-chip
              v-if="item.mt_time_3_score > 0"
              color="info"
              @click="viewFileScore((param = item.mt_time_3_file))"
            >
              <span class="font-weight-bold warning--text">{{
                item.mt_time_3_score
              }}</span>
            </v-chip>
          </template>

          <template v-slot:item.mt_time_4_score="{ item }">
            <div v-if="item.mt_time_4_ck === 'Pass'">
              <v-btn color="success" icon small>
                <v-icon>mdi-check-circle</v-icon>
              </v-btn>
            </div>
            <v-chip
              v-if="item.mt_time_4_score > 0"
              color="info"
              @click="viewFileScore((param = item.mt_time_4_file))"
            >
              <span class="font-weight-bold warning--text">{{
                item.mt_time_4_score
              }}</span>
            </v-chip>
          </template>

          <template v-slot:item.assistant_teacher_re_status="{ item }">
            <div v-if="item.assistant_teacher_re_status === 'CC'">
              <v-icon size="30" color="error"> mdi-alert</v-icon>
            </div>
            <div
              v-else-if="
                String(item.assistant_teacher_re_leaveguarantee).length > 4
              "
            >
              <v-icon size="30" color="success">mdi-check-circle</v-icon>
            </div>
          </template>

          <template v-slot:item.assistant_teacher_re_leaveguarantee="{ item }">
            <div
              v-if="String(item.assistant_teacher_re_leaveguarantee).length > 4"
            >
              <v-btn
                @click="
                  viewFileleavegurantee(
                    item.assistant_teacher_re_leaveguarantee
                  )
                "
                fab
                small
                color="info"
              >
                <v-icon size="30">mdi-printer</v-icon>
              </v-btn>
            </div>
          </template>

          <template v-slot:item.assistant_teacher_re_status_detail="{ item }">
            <div
              v-if="item.assistant_teacher_re_status === 'CC'"
              class="error--text"
            >
              {{ item.assistant_teacher_re_status_detail }}
            </div>
          </template>

          <template v-slot:item.evaluate_s="{ item }">
            <v-chip
              color="success"
              dark
              v-if="item.report_id_card === item.id_card"
            >
              <h2>
                <v-icon>mdi-checkbox-marked-circle</v-icon> ส่งผลการประเมิน
              </h2>
            </v-chip>
            <v-chip
              v-else-if="
                item.last_time_ass === '1' ||
                  item.last_time_ass === '2' ||
                  item.last_time_ass === '3' ||
                  item.last_time_ass === '4'
              "
              color="info"
              @click.stop="evaluate_assistant(item.mt_id_card)"
              dark
            >
              <h2>{{ item.last_time_ass }}</h2>
            </v-chip>
            <v-chip
              v-else
              dark
              color="error"
              @click.stop="evaluate_assistant(item.mt_id_card)"
            >
              <h2>
                <v-icon class="pa-1">mdi-cursor-pointer</v-icon>
                ไม่ได้เริ่มประเมิน
              </h2>
            </v-chip>
          </template>

          <template v-slot:item.prints="{ item }">
            <v-chip
              color="info"
              dark
              v-if="item.report_id_card === item.id_card"
            >
              <h2><v-icon>mdi-printer</v-icon> พิมพ์รายงาน</h2>
            </v-chip>
            <v-chip
              v-else-if="
                item.last_time_ass === '1' ||
                  item.last_time_ass === '2' ||
                  item.last_time_ass === '3' ||
                  item.last_time_ass === '4'
              "
              color="info"
              dark
            >
              <h2>อยู่ระหว่างการประเมิน</h2>
            </v-chip>
            <v-chip v-else color="error" dark>
              <h2>ไม่ได้เริ่มประเมิน</h2>
            </v-chip>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon
              color="warning"
              @click.stop="assistant_teacher_reportEdit(item.id_rc)"
            >
              mdi-pencil
            </v-icon>
          </template>

          <template v-slot:item.cancels="{ item }">
            <v-icon
              color="error"
              @click.stop="evaluate_assistant(item.mt_id_card)"
            >
              mdi-cancel
            </v-icon>
          </template>

          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </base-material-card>

      <!-- V-model evaluate_assistantdialog -->
      <v-layout row justify-center>
        <v-dialog v-model="evaluate_assistantdialog" persistent max-width="80%">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="success"
              icon="mdi-clipboard-text"
              title="บันทึกคะแนนการประเมิน รายบุคคล"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form ref="evaluate_assistantform" lazy-validation>
                <v-container grid-list-md>
                  <v-card>
                    <template slot="progress">
                      <v-progress-linear
                        color="primary"
                        height="10"
                        indeterminate
                      ></v-progress-linear>
                    </template>

                    <v-card-title
                      ><v-icon large color="info">mdi-account-check</v-icon>
                      <h2>ข้อมูลครูผู้ช่วย ผู้รับการประเมิน</h2></v-card-title
                    >
                    <v-card-text>
                      <div class="my-4">
                        <h3>
                          สถานศึกษา :
                          {{ assistant_teacher_report_id_card.user_firstname }}
                        </h3>
                        รหัสบัตรประชาชน :
                        {{
                          assistant_teacher_report_id_card.assistant_teacher_re_id_card
                        }}
                        <br />
                        ชื่อ-นามสกุล :
                        {{ assistant_teacher_report_id_card.frist_names }}
                        <br />
                        วันที่บรรจุ :
                        {{
                          assistant_teacher_report_id_card.mt_date_app_now
                            | moment("add", "543 year")
                            | moment("D MMMM YYYY")
                        }}
                        <br />
                        คำสั่งที่บรรจุ :
                        {{ assistant_teacher_report_id_card.mt_order_app }}
                      </div>
                      <div class="my-4"></div>
                    </v-card-text>

                    <v-divider class="mx-4"></v-divider>

                    <v-card-title class="text-center">
                      <h3>ส่งผลการประเมิน</h3>
                    </v-card-title>
                    <v-row>
                      <v-col cols="12">
                        <v-data-table
                          :headers="headers_aassistant_teacher"
                          :items="assistant_teachers"
                          class="elevation-1"
                          :loading="loading"
                        >
                          |<!--  moment("add","543 years") | moment("D MMMM YYYY") -->

                          <template
                            v-slot:item.assistant_teacher_file="{ item }"
                          >
                            <v-btn
                              v-if="item.assistant_teacher_file"
                              large
                              icon
                              color="info"
                              @click="viewfilePDF(item.assistant_teacher_file)"
                            >
                              <v-icon>mdi-printer</v-icon>
                            </v-btn>
                          </template>

                          <template
                            v-slot:item.assistant_teacher_datetime="{
                              item
                            }"
                          >
                            {{
                              item.assistant_teacher_datetime
                                | moment("add", "543 years")
                                | moment("D MMMM YYYY")
                            }}
                          </template>

                          <template
                            v-slot:item.assistant_teacher_status="{ item }"
                          >
                            <v-chip
                              v-if="item.assistant_teacher_status === 'confirm'"
                              color="success"
                              dark
                            >
                              <h2>ส่งผลการประเมินเรียบร้อย</h2>
                            </v-chip>
                            <v-chip v-else color="warning" dark>
                              <h2>อยู่ระหว่างการประเมินผล</h2>
                            </v-chip>
                          </template>

                          <template
                            v-slot:item.assistant_teacher_comment="{ item }"
                          >
                            <v-icon
                              v-if="item.assistant_teacher_status === 'confirm'"
                              color="success"
                              large
                            >
                              mdi-cube-send
                            </v-icon>
                            <v-icon
                              v-else
                              large
                              color="warning"
                              @click.stop="
                                assistant_teacherEdit(item.assistant_teacher_id)
                              "
                            >
                              mdi-pencil
                            </v-icon>
                          </template>
                        </v-data-table>

                        <v-simple-table>
                          <tbody>
                            <tr>
                              <td class="text-center">
                                วันที่ส่งรายงาน :
                                {{
                                  assistant_teacher_report_id_card.assistant_teacher_re_datetime
                                }}
                              </td>
                              <td class="text-center">
                                คะแนนเฉลี่ยรวม :
                                {{
                                  assistant_teacher_report_id_card.assistant_teacher_re_avg_score
                                }}
                              </td>

                              <td class="text-center">
                                จำนวนวันลา :
                                {{
                                  assistant_teacher_report_id_card.assistant_teacher_re_leaveday
                                }}
                                วัน
                              </td>

                              <td class="text-center">
                                หนังสือรับรอง :
                                <v-btn
                                  @click="
                                    viewFileleavegurantee(
                                      assistant_teacher_report_id_card.assistant_teacher_re_leaveguarantee
                                    )
                                  "
                                  color="info"
                                  fab
                                  small
                                  ><v-icon>mdi-printer</v-icon></v-btn
                                >
                              </td>

                              <td
                                class="text-center error--text font-weight-bold"
                              >
                                หมายเหตุ
                                {{
                                  assistant_teacher_report_id_card.assistant_teacher_re_status_detail
                                }}
                              </td>

                              <td class="text-center">
                                <v-btn
                                  @click="assistant_teacher_reportSubmit()"
                                  outlined
                                  color="warning"
                                >
                                  <v-icon size="30" color="warning"
                                    >mdi-alert</v-icon
                                  >
                                  ยกเลิกรายการ สรุปวันลา</v-btn
                                >
                              </td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                    <v-card-actions>
                      <v-btn
                        @click="cancel_assistant_teacher_report()"
                        color="error"
                        outlined
                        rounded
                      >
                        <v-icon>mdi-alert</v-icon>
                        &nbsp; ยกเลิกรายการประเมิน
                      </v-btn>
                      <v-spacer></v-spacer>

                      <v-btn
                        outlined
                        @click.stop="evaluate_assistantdialog = false"
                        rounded
                      >
                        <v-icon dark>mdi-close</v-icon>ปิด
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model assistant_teacherdialog -->
      <v-layout row justify-center>
        <v-dialog v-model="assistant_teacherdialog" persistent max-width="60%">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="success"
              icon="mdi-clipboard-text"
              title="บันทึกคะแนนประเมิน"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form ref="assistant_teacherdialogform" lazy-validation>
                <v-container grid-list-md>
                  <v-card-text>
                    <div class="my-4">
                      <h3>
                        สถานศึกษา :
                        {{ assistant_teacher_report_id_card.college_name }}
                      </h3>
                      รหัสบัตรประชาชน :
                      {{
                        assistant_teacher_report_id_card.assistant_teacher_re_id_card
                      }}
                      <br />
                      ชื่อ-นามสกุล :
                      {{ assistant_teacher_report_id_card.frist_names }} <br />
                      วันที่บรรจุ :
                      {{ assistant_teacher_report_id_card.date_app }} <br />
                      คำสั่งที่บรรจุ :
                      {{ assistant_teacher_report_id_card.order_app_now }}
                      <br />
                      <br />

                      <h3>ครั้งที่ประเมิน : {{ times_s }}</h3>
                    </div>
                    <div class="my-4"></div>
                  </v-card-text>
                  <v-layout wrap>
                    <v-flex md12 class="text-center">
                      <h3>คะแนนประเมิน</h3>
                    </v-flex>
                    <v-flex md6>
                      <v-text-field
                        v-model="addassistant_teacher.assistant_teacher_score"
                        type="number"
                        label="คะแนน"
                        required
                        :rules="[
                          v => !!v || '',
                          v => (!!v && v <= 100) || 'กรอกคะแนนไม่ถูกต้อง'
                        ]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md6>
                      <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="
                              addassistant_teacher.assistant_teacher_datetime
                            "
                            label="วันที่ประเมิน"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            locale="th"
                            required
                            :rules="[v => !!v || '']"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="
                            addassistant_teacher.assistant_teacher_datetime
                          "
                          no-title
                          scrollable
                          locale="th"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu2 = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu2.save(date)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-container>
                <strong class="error--text"
                  >* ปีที่ 1 (ไม่ต่ำกว่าร้อยละ 60 จึงจะถือว่า
                  ผ่านการประเมิน)</strong
                >
                <br />
                <strong class="error--text"
                  >* ปีที่ 2 (ไม่ต่ำกว่าร้อยละ 70 จึงจะถือว่า
                  ผ่านการประเมิน)</strong
                >
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="warning"
                large
                @click.stop="assistant_teacherdialog = false"
                rounded
              >
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="success"
                @click.stop="assistant_teacherdialogSubmit()"
                rounded
              >
                <v-icon dark>mdi-content-save</v-icon>&nbsp;บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model assistant_teacherEditdialog -->
      <v-layout row justify-center>
        <v-dialog
          v-model="assistant_teacherEditdialog"
          persistent
          max-width="60%"
        >
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="warning"
              icon="mdi-clipboard-text"
              title="แก้ไขคะแนนประเมิน"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form ref="assistant_teacherEditform" lazy-validation>
                <v-container grid-list-md>
                  <v-card-text>
                    <div class="my-4">
                      <h3>
                        สถานศึกษา :
                        {{ assistant_teacher_report_id_card.college_name }}
                      </h3>
                      รหัสบัตรประชาชน :
                      {{
                        assistant_teacher_report_id_card.assistant_teacher_re_id_card
                      }}
                      <br />
                      ชื่อ-นามสกุล :
                      {{ assistant_teacher_report_id_card.frist_names }} <br />
                      วันที่บรรจุ :
                      {{ assistant_teacher_report_id_card.date_app }} <br />
                      คำสั่งที่บรรจุ :
                      {{ assistant_teacher_report_id_card.order_app_now }}
                      <br />
                      <br />

                      <h3>
                        ครั้งที่ประเมิน :
                        {{ assistant_teachers_edit.assistant_teacher_times }}
                      </h3>
                    </div>
                    <div class="my-4"></div>
                  </v-card-text>
                  <v-layout wrap>
                    <v-flex md12 class="text-center">
                      <h3>คะแนนประเมิน</h3>
                    </v-flex>
                    <v-flex md6>
                      <v-text-field
                        v-model="
                          assistant_teachers_edit.assistant_teacher_score
                        "
                        type="number"
                        label="คะแนน"
                        required
                        :rules="[
                          v => !!v || '',
                          v => (!!v && v <= 100) || 'กรอกคะแนนไม่ถูกต้อง'
                        ]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md6>
                      <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="
                              assistant_teachers_edit.assistant_teacher_datetime
                            "
                            label="วันที่ประเมิน"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            locale="th"
                            required
                            :rules="[v => !!v || '']"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="
                            assistant_teachers_edit.assistant_teacher_datetime
                          "
                          no-title
                          scrollable
                          locale="th"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu1 = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu1.save(date)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-container>
                <strong class="error--text"
                  >* ปีที่ 1 (ไม่ต่ำกว่าร้อยละ 60 จึงจะถือว่า
                  ผ่านการประเมิน)</strong
                >
                <br />
                <strong class="error--text"
                  >* ปีที่ 2 (ไม่ต่ำกว่าร้อยละ 70 จึงจะถือว่า
                  ผ่านการประเมิน)</strong
                >
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="warning"
                large
                @click.stop="assistant_teacherEditdialog = false"
                rounded
              >
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="success"
                @click.stop="assistant_teacherEditdialogSubmit()"
                rounded
              >
                <v-icon dark>mdi-content-save</v-icon>&nbsp;บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model assistant_teacherConfirmdialog -->
      <v-layout row justify-center>
        <v-dialog
          v-model="assistant_teacherConfirmdialog"
          persistent
          max-width="60%"
        >
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="warning"
              icon="mdi-clipboard-text"
              title="ยืนยันผลการประเมิน"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form ref="assistant_teacherConfirmdialogform" lazy-validation>
                <v-container grid-list-md>
                  <v-card-text>
                    <div class="my-4">
                      <h3>
                        สถานศึกษา :
                        {{ assistant_teacher_report_id_card.college_name }}
                      </h3>
                      รหัสบัตรประชาชน :
                      {{
                        assistant_teacher_report_id_card.assistant_teacher_re_id_card
                      }}
                      <br />
                      ชื่อ-นามสกุล :
                      {{ assistant_teacher_report_id_card.frist_names }} <br />
                      วันที่บรรจุ :
                      {{ assistant_teacher_report_id_card.date_app }} <br />
                      คำสั่งที่บรรจุ :
                      {{ assistant_teacher_report_id_card.order_app_now }}
                      <br />
                      <h3>
                        คะแนนเฉลี่ย :
                        {{ assistant_teacher_report_id_card.avg_score }}
                      </h3>
                      <br />

                      <h3>
                        หากกดปุ่มยืนยันแล้วจะไม่สามารถดำเนินการแก้ไขได้
                        กรุณาตรวจสอบให้ถูกต้องก่อนกดปุ่มยืนยัน
                      </h3>
                    </div>
                    <div class="my-4"></div>
                  </v-card-text>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                large
                @click.stop="assistant_teacherConfirmdialog = false"
                rounded
              >
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="warning"
                @click.stop="assistant_teacherConfirmdialogSubmit()"
                rounded
              >
                <v-icon dark>mdi-pencil</v-icon>&nbsp;ยืนยันผลการประเมิน
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model cancel_assistant_teacher_reportdialog -->
      <v-layout row justify-center>
        <v-dialog
          v-model="cancel_assistant_teacher_reportdialog"
          persistent
          max-width="60%"
        >
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="warning"
              icon="mdi-clipboard-text"
              title="ยกเลิกการประเมินผล"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form
                ref="cancel_assistant_teacher_reportdialogform"
                lazy-validation
              >
                <v-container grid-list-md>
                  <v-card-text>
                    <div class="my-4">
                      <h3>
                        สถานศึกษา :
                        {{ assistant_teacher_report_id_card.user_firstname }}
                      </h3>
                      รหัสบัตรประชาชน :
                      {{
                        assistant_teacher_report_id_card.assistant_teacher_re_id_card
                      }}
                      <br />
                      ชื่อ-นามสกุล :
                      {{ assistant_teacher_report_id_card.frist_names }}
                      <br />
                      วันที่บรรจุ :
                      {{
                        assistant_teacher_report_id_card.mt_date_app_now
                          | moment("add", "543 year")
                          | moment("D MMMM YYYY")
                      }}
                      <br />
                      คำสั่งที่บรรจุ :
                      {{ assistant_teacher_report_id_card.mt_order_app }}
                    </div>
                    <div class="my-4">
                      <v-text-field
                        v-model="
                          cancel_assistant_teachers.assistant_teacher_ipacomment
                        "
                        label="เหตุผลในการยกเลิก"
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </div>
                  </v-card-text>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                large
                @click.stop="cancel_assistant_teacher_reportdialog = false"
                rounded
              >
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="warning"
                @click.stop="cancel_assistant_teacher_reportdialogSubmit()"
                rounded
              >
                <v-icon dark>mdi-pencil</v-icon
                >&nbsp;ยืนยันการยกเลิกผลการประเมิน
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model pertem_assistantFileCCdialog -->
      <v-layout row justify-center>
        <v-dialog
          v-model="pertem_assistantFileCCdialog"
          persistent
          max-width="60%"
        >
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="error"
              icon="mdi-clipboard-text"
              title="ยกเลิกแนบคำสั่งแต่งตั้งกรรมการประเมิน"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form ref="pertem_assistantFileCCform" lazy-validation>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md12>
                      <div class="my-4">
                        <h3>
                          สถานศึกษา :
                          {{ editassistant_teacher_report.college_name }}
                        </h3>
                        รหัสบัตรประชาชน :
                        {{ editassistant_teacher_report.id_card }} <br />
                        ชื่อ-นามสกุล :
                        {{ editassistant_teacher_report.frist_names }} <br />
                        วันที่บรรจุ :
                        {{ editassistant_teacher_report.date_app }} <br />
                        คำสั่งที่บรรจุ :
                        {{ editassistant_teacher_report.order_app_now }}
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="success"
                @click.stop="pertem_assistantFileCCSubmit()"
                rounded
              >
                <v-icon dark>mdi-checkbox-marked-circle</v-icon
                >&nbsp;ยืนยันยกเลิก
              </v-btn>
              <v-btn
                outlined
                color="warning"
                @click.stop="pertem_assistantFileCCdialog = false"
                rounded
              >
                <v-icon dark>mdi-close</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model editassistant_teacher_reportdialog -->
      <v-layout row justify-center>
        <v-dialog
          v-model="editassistant_teacher_reportdialog"
          persistent
          max-width="60%"
        >
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="warning"
              icon="mdi-clipboard-text"
              title="ปรับปรุงข้อมูลบุคลากร"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form ref="editassistant_teacher_reportform" lazy-validation>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md12>
                      <h3>ข้อมูลการเริ่มปฏิบัติหน้าที่ในสถานศึกษาปัจจุบัน</h3>
                    </v-flex>
                    <v-flex md6>
                      <v-text-field
                        label="คำสั่งที่ ระบุเพียง : 783/2563"
                        v-model="editassistant_teacher_report.order_app_now"
                        required
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md6>
                      <v-menu
                        ref="menu3"
                        v-model="menu3"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editassistant_teacher_report.date_app_now"
                            label="วันเดือนเริ่มปฏิบัติงาน"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            locale="th"
                            required
                            :rules="[v => !!v || '']"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="editassistant_teacher_report.date_app_now"
                          no-title
                          scrollable
                          locale="th"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu3 = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu3.save(date)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-container>
                <strong class="error--text">* จำเป็น</strong>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="warning"
                large
                @click.stop="editassistant_teacher_reportdialog = false"
                rounded
              >
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="success"
                @click.stop="editassistant_teacher_reportSubmit()"
                rounded
              >
                <v-icon dark>mdi-content-save</v-icon>&nbsp;บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout row justify-center>
        <v-dialog v-model="pdflicenseteachdialog" max-width="80%">
          <v-card class="" elevation="2">
            <embed
              :src="
                'https://hrvec.ovec.go.th/HRvecLicenseTeach/' + pt_licence_files
              "
              width="100%"
              height="700px"
            />
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout row justify-center>
        <v-dialog v-model="scoredialog" max-width="80%">
          <v-card class="" elevation="2">
            <embed
              :src="'https://hrvec.ovec.go.th/HRvecfiles/' + assFileScore"
              width="100%"
              height="700px"
            />
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout row justify-center>
        <v-dialog
          v-model="assistant_teacher_re_leaveguaranteedialog"
          max-width="80%"
        >
          <v-card class="" elevation="2">
            <embed
              :src="
                'https://hrvec.ovec.go.th/HRvecAssistant_report/' +
                  assistant_teacher_re_leaveguarantee
              "
              width="100%"
              height="700px"
            />
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- ยกเลิกไฟล์แนบใบอนุญาตประกอบวิชาชีพครู -->

      <v-dialog v-model="cancel_Licensefiledialog" persistent max-width="60%">
        <v-card class="mx-auto pa-6">
          <base-material-card
            color="warning"
            icon="mdi-clipboard-text"
            title="การตรวจสอบข้อมูล ใบอนุญาตประกอบวิชาชีพครู/ใบอนุญาตปฏิบัติการสอน"
            class="px-5 py-3 text_google"
          ></base-material-card>
          <v-card-text>
            <v-form ref="cancel_Licensefiledialogform" lazy-validation>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex md12>
                    <div class="text-center">
                      <v-btn
                        v-if="
                          String(editmanage_assistant_teacher.pt_licence_file)
                            .length > 6
                        "
                        color="info"
                        icon
                        @click="
                          viewpdflicenseteach(
                            editmanage_assistant_teacher.pt_licence_file
                          )
                        "
                        ><v-icon size="60">mdi-printer</v-icon></v-btn
                      >
                    </div>

                    <div class="text-center">
                      <v-btn
                        v-if="
                          String(
                            editmanage_assistant_teacher.pt_licence_file_tem
                          ).length > 6
                        "
                        color="info"
                        icon
                        @click="
                          viewpdflicenseteach(
                            editmanage_assistant_teacher.pt_licence_file_tem
                          )
                        "
                        ><v-icon size="60">mdi-printer</v-icon></v-btn
                      >
                    </div>

                    <br />
                    ชื่อ-นามสกุล :
                    <span class="font-weight-bold"
                      >{{ editmanage_assistant_teacher.frist_names }}
                    </span>
                    <br />
                    ID-card :
                    {{ editmanage_assistant_teacher.mt_id_card }}
                  </v-flex>

                  <v-flex
                    md6
                    v-if="
                      editmanage_assistant_teacher.mt_license_status === 'have'
                    "
                  >
                    <v-radio-group
                      v-model="editmanage_assistant_teacher.pt_licence_file_ipa"
                      row
                      :rules="[v => !!v || '']"
                    >
                      <template v-slot:label>
                        <div><strong>การตรวจสอบข้อมูล</strong></div>
                      </template>
                      <v-radio value="pass">
                        <template v-slot:label>
                          <div>
                            <strong class="success--text">ผ่าน</strong>
                          </div>
                        </template>
                      </v-radio>
                      <v-radio value="dontpass">
                        <template v-slot:label>
                          <div>
                            <strong class="primary--text">ไม่ผ่าน</strong>
                          </div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-flex>

                  <v-flex
                    md6
                    v-if="
                      editmanage_assistant_teacher.pt_licence_file_ipa ===
                        'dontpass' &&
                        editmanage_assistant_teacher.mt_license_status ===
                          'have'
                    "
                  >
                    <v-text-field
                      label="เหตุผล"
                      v-model="
                        editmanage_assistant_teacher.pt_licence_file_ipacomment
                      "
                      required
                      :rules="[v => !!v || '']"
                      outlined
                    ></v-text-field>
                  </v-flex>

                  <v-flex
                    md6
                    v-if="
                      editmanage_assistant_teacher.mt_license_status === 'donot'
                    "
                  >
                    <v-radio-group
                      v-model="
                        editmanage_assistant_teacher.pt_licence_file_ipa_tem
                      "
                      row
                      :rules="[v => !!v || '']"
                    >
                      <template v-slot:label>
                        <div>
                          การตรวจสอบข้อมูล<strong>
                            ใบอนุญาตปฏิบัติการสอน</strong
                          >
                        </div>
                      </template>
                      <v-radio value="pass">
                        <template v-slot:label>
                          <div>
                            <strong class="success--text">ผ่าน</strong>
                          </div>
                        </template>
                      </v-radio>
                      <v-radio value="dontpass">
                        <template v-slot:label>
                          <div>
                            <strong class="primary--text">ไม่ผ่าน</strong>
                          </div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-flex>

                  <v-flex
                    md6
                    v-if="
                      editmanage_assistant_teacher.pt_licence_file_ipa_tem ===
                        'dontpass' &&
                        editmanage_assistant_teacher.mt_license_status ===
                          'donot'
                    "
                  >
                    <v-text-field
                      label="เหตุผล"
                      v-model="
                        editmanage_assistant_teacher.pt_licence_file_ipacomment_tem
                      "
                      required
                      :rules="[v => !!v || '']"
                      outlined
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
              <strong class="error--text">* จำเป็น</strong>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              outlined
              @click.stop="cancel_Licensefiledialog = false"
              rounded
            >
              <v-icon dark>mdi-close</v-icon>
            </v-btn>

            <v-btn
              outlined
              color="success"
              @click.stop="cancel_LicensefiledialogSubmit()"
              rounded
            >
              <v-icon dark>mdi-content-save</v-icon>&nbsp;บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-layout row justify-center>
        <v-dialog v-model="importCsvDialog" max-width="500px" persistent>
          <v-card class="mx-auto pa-4">
            <base-material-card
              color="primary"
              icon="mdi-file-delimited"
              title="นำเข้าข้อมูลจาก CSV (อนุมัติ คศ.1)"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text class="pt-4">
              <v-alert type="info" outlined dense class="mb-4">
                ไฟล์ CSV ต้องมี 2 คอลัมน์ (ไม่ต้องมี Header):<br />
                <b>คอลัมน์ 1:</b> รหัสบัตรประชาชน 13 หลัก<br />
                <b>คอลัมน์ 2:</b> วันที่ดำรงตำแหน่ง (รูปแบบ YYYY-MM-DD เช่น
                2026-03-30)
              </v-alert>

              <v-file-input
                v-model="csvFile"
                accept=".csv"
                label="เลือกไฟล์ CSV"
                placeholder="อัปโหลดไฟล์ที่นี่"
                prepend-icon="mdi-file-delimited"
                outlined
                dense
                show-size
              ></v-file-input>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large rounded @click="importCsvDialog = false">
                <v-icon dark left>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="primary"
                rounded
                @click="processCSV()"
                :loading="csvLoading"
              >
                <v-icon dark left>mdi-upload</v-icon>นำเข้าข้อมูล
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>

    <v-container fluid>
      <v-snackbar
        v-model="snackbar.show"
        top
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        <v-icon large>{{ snackbar.icon }}</v-icon>
        <v-card-text>
          {{ snackbar.text }}
        </v-card-text>

        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false"
            >Close</v-btn
          >
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
import Assistant_teacher_bar from "../../components/admin/assistant_teacher_bar.vue";
export default {
  data() {
    return {
      loading: false,
      ApiKey: "HRvec2021",
      valid: true,
      scoredialog: false,
      assFileScore: "",
      addassistant_teacher_reportdialog: false,
      editassistant_teacher_reportdialog: false,
      deleteassistant_teacher_reportdialog: false,
      evaluate_assistantdialog: false,
      assistant_teacherdialog: false,
      assistant_teacherEditdialog: false,
      assistant_teacherConfirmdialog: false,
      cancel_assistant_teacher_reportdialog: false,
      pertem_assistantFileCCdialog: false,
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      assistant_teacher_reports: [],
      addassistant_teacher_report: {},
      editassistant_teacher_report: {},
      search: "",
      pagination: {},
      headers: [
        { text: "ลำดับ", align: "center", value: "order_number" },
        { text: "ประเภท", align: "left", value: "mt_type_personnel" },
        { text: "รหัสสถานศึกษา", align: "left", value: "mt_college_code" },
        { text: "เข้าสู่ระบบสถานศึกษา", align: "left", value: "LoginAdmin" },
        { text: "สถานศึกษา", align: "left", value: "user_firstname" },
        { text: "จังหวัด", align: "left", value: "province_name" },
        { text: "รหัสบัตรประชาชน", align: "left", value: "mt_id_card" },
        { text: "ชื่อ-นามสกุล", align: "left", value: "frist_names" },
        { text: "เลขที่ตำแหน่ง", align: "center", value: "mt_id_position" },
        { text: "ใบประกอบวิชาชีพ", align: "center", value: "pt_licence" },
        { text: "คุรุสภา", align: "center", value: "pt_licence_ict" },
        { text: "อนุมัติ คศ.1", align: "center", value: "approve_level1" },

        { text: "ครั้งที่ 1", align: "center", value: "mt_time_1_score" },
        { text: "ครั้งที่ 2", align: "center", value: "mt_time_2_score" },
        { text: "ครั้งที่ 3", align: "center", value: "mt_time_3_score" },
        { text: "ครั้งที่ 4", align: "center", value: "mt_time_4_score" },
        {
          text: "คะแนน",
          align: "center",
          value: "assistant_teacher_re_avg_score"
        },

        {
          text: "วันลา",
          align: "center",
          value: "assistant_teacher_re_leaveday"
        },

        {
          text: "ไฟล์รับรองวันลา",
          align: "center",
          value: "assistant_teacher_re_leaveguarantee"
        },

        {
          text: "สถานะ",
          align: "center",
          value: "assistant_teacher_re_status"
        },
        {
          text: "หมายเหตุ",
          align: "center",
          value: "assistant_teacher_re_status_detail"
        },

        { text: "วันเดือนปีบรรจุ", align: "center", value: "mt_date_app_now" },
        { text: "คำสั่งที่", align: "center", value: "mt_order_app" },
        {
          text: "วันที่รายงาน",
          align: "center",
          value: "assistant_teacher_re_datetime"
        },
        {
          text: "ยกเลิกการประเมิน",
          align: "center",
          value: "cancels",
          icon: "mdi-cancel"
        }
      ],
      headers_aassistant_teacher: [
        { text: "ครั้งที่", align: "center", value: "assistant_teacher_times" },
        {
          text: "สถานศึกษา",
          align: "left",
          value: "user_firstname"
        },
        {
          text: "รหัสบัตรประชาชน",
          align: "left",
          value: "assistant_teacher_id_card"
        },
        {
          text: "ชื่อ-นามสกุล",
          align: "left",
          value: "frist_names"
        },
        {
          text: "วันที่ประเมิน",
          align: "center",
          value: "assistant_teacher_datetime"
        },
        { text: "คะแนน", align: "center", value: "assistant_teacher_score" },
        { text: "สถานะ", align: "center", value: "assistant_teacher_status" },
        { text: "ไฟล์แนบ", align: "center", value: "assistant_teacher_file" },
        {
          text: "รายงาน",
          align: "center",
          value: "assistant_teacher_comment"
        },

        {
          text: "สอศ.ตรวจสอบ",
          align: "center",
          value: "assistant_teacher_ipacheck"
        }
      ],
      rang_names: [
        { text: "ชำนาญการ", value: "ชำนาญการ" },
        { text: "ชำนาญการพิเศษ", value: "ชำนาญการพิเศษ" },
        { text: "เชี่ยวชาญ", value: "เชี่ยวชาญ" },
        { text: "เชี่ยวชาญพิเศษ", value: "เชี่ยวชาญพิเศษ" }
      ],
      rang_levels: ["-", 1, 2, 3, 4, 5],
      rowsperpage: [
        25,
        50,
        100,
        {
          text: "All",
          value: -1
        }
      ],
      select_per: "",
      select_personel: [
        { text: "ประเมินครั้งที่ 1 ", value: "1" },
        { text: "ประเมินครั้งที่ 2 ", value: "2" },
        { text: "ประเมินครั้งที่ 3 ", value: "3" },
        { text: "ประเมินครั้งที่ 4 ", value: "4" }
      ],
      college: {},
      provinces: [],
      prefectures: [],
      userstatus: [],
      man_powers: [],
      collgegs: [],
      assistant_teacher_reportstatus: [],
      regions: [],
      region_ena: true,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      assistant_teacher_report_id_card: [],
      assistant_teachers: [],
      addassistant_teacher: {},
      assistant_teachers_edit: {},
      assistant_teachers_confrim: {},
      assistant_teacher_report_s: {},
      result_assistant_teacher_reports: {},
      cancel_assistant_teacher_reports: {},
      cancel_assistant_teachers: {},
      data_syslog: {},
      colleges: [],
      college_select: "",
      Updateassistant_teacher_report: {},
      groupDateTimeApps: [],
      dateTimeAppSelect: null,
      pdflicenseteachdialog: false,
      pt_licence_files: "",
      check_param_query: [],
      check_CC: [],
      assistant_teacher_re_leaveguarantee: "",
      assistant_teacher_re_leaveguaranteedialog: false,
      editmanage_assistant_teacher: [],
      cancel_Licensefiledialog: false,
      user_id: [],
      // New data for charts and statistics
      chartOptions: {},
      statisticsCards: [
        {
          label: "ครูผู้ช่วยทั้งหมด",
          value: 0,
          icon: "mdi-account-group",
          color: "stat-card-blue",
          iconColor: "white"
        },
        {
          label: "คุณสมบัติครบถ้วน",
          value: 0,
          icon: "mdi-check-circle",
          color: "stat-card-green",
          iconColor: "white"
        },
        {
          label: "ขาดไปประกอบวิชาชีพ",
          value: 0,
          icon: "mdi-clock-outline",
          color: "stat-card-orange",
          iconColor: "white"
        },
        {
          label: "ขาดสรุปวันลา",
          value: 0,
          icon: "mdi-alert-circle",
          color: "stat-card-red",
          iconColor: "white"
        }
      ],

      importCsvDialog: false,
      csvFile: null,
      csvLoading: false
    };
  },
  async mounted() {
    await this.userQueryID();
    await this.groupDateTimeAppQuery();
    await this.checkappoint();
    this.$nextTick(() => {
      this.initializeCharts();
    });

    let result;
    result = await this.$http.post("college.php", {
      ApiKey: this.ApiKey
    });
    this.colleges = result.data;
    let user_status_result;
    user_status_result = await this.$http.post(
      "crud_user_status.php?crud=read",
      {
        ApiKey: this.ApiKey
      }
    );
    this.userstatus = user_status_result.data;
  },
  methods: {
    async processCSV() {
      if (!this.csvFile) {
        Swal.fire({
          icon: "warning",
          title: "กรุณาเลือกไฟล์ CSV",
          timer: 1500
        });
        return;
      }

      this.csvLoading = true;
      const reader = new FileReader();

      reader.onload = async e => {
        const text = e.target.result;
        const rows = text.split("\n").filter(row => row.trim() !== "");
        const dataToImport = [];

        for (let i = 0; i < rows.length; i++) {
          // แยกระหว่าง comma เครื่องหมายลูกน้ำ
          const cols = rows[i].split(",").map(c => c.trim().replace(/"/g, ""));

          // เช็คว่ามีข้อมูลอย่างน้อย 2 คอลัมน์ และคอลัมน์แรกเป็นตัวเลข (รหัสบัตร)
          if (cols.length >= 2 && cols[0].length >= 10 && !isNaN(cols[0])) {
            dataToImport.push({
              id_card: cols[0],
              date_app_positonnow: cols[1]
            });
          }
        }

        if (dataToImport.length === 0) {
          Swal.fire(
            "ข้อผิดพลาด",
            "รูปแบบไฟล์ไม่ถูกต้อง หรือไม่มีข้อมูลให้ทำรายการ",
            "error"
          );
          this.csvLoading = false;
          return;
        }

        try {
          let result = await this.$http.post(
            "personnel_temporary.update.csv.php",
            {
              ApiKey: this.ApiKey,
              data: dataToImport
            }
          );

          if (result.data.status === true) {
            Swal.fire({
              icon: "success",
              title: "อัปเดตข้อมูลสำเร็จ",
              text: `ทำรายการผ่านทั้งหมด ${result.data.updated} รายการ`
            });
            this.importCsvDialog = false;
            this.csvFile = null;
            this.checkappoint(); // รีเฟรชตารางใหม่
          } else {
            Swal.fire({
              icon: "warning",
              title: "เสร็จสิ้นบางส่วน",
              text: `อัปเดตสำเร็จ ${result.data.updated || 0} จาก ${
                dataToImport.length
              } รายการ (อาจมีข้อมูลซ้ำ หรือรหัสบัตรไม่ตรง)`
            });
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาดในการเชื่อมต่อ API"
          });
        }
        this.csvLoading = false;
      };

      reader.readAsText(this.csvFile);
    },
    async approveTeach() {
      let payload = this.assistant_teacher_reports.map(item => ({
        appoin_day: item.mt_appoin_day,
        appoin_month: item.mt_appoin_month,
        appoin_year: item.mt_appoin_year,
        id_card: item.mt_id_card
      }));

      try {
        let result = await this.$http.post(
          "personnel_temporary.update.level1.php",
          {
            ApiKey: this.ApiKey,
            data: payload
          }
        );
        if (result.data.status === true) {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "ไม่สามารถอัปเดตข้อมูลได้",
            text: `อัปเดตสำเร็จ ${result.data.updated || 0} รายการ`
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาดในการเชื่อมต่อ API"
        });
      }
    },

    async approveTeach_id(item) {
      let payload = {
        appoin_day: item.mt_appoin_day,
        appoin_month: item.mt_appoin_month,
        appoin_year: item.mt_appoin_year,
        id_card: item.mt_id_card
      };

      try {
        let result = await this.$http.post(
          "personnel_temporary.update.level1.php",
          {
            ApiKey: this.ApiKey,
            data: payload
          }
        );

        if (result.data.status === true) {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          await this.checkappoint();
        } else {
          Swal.fire({
            icon: "error",
            title: "ไม่สามารถอัปเดตข้อมูลได้",
            text: `อัปเดตสำเร็จ ${result.data.updated || 0} รายการ`
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาดในการเชื่อมต่อ API"
        });
      }
    },

    initializeCharts() {
      try {
        this.loading = true;
        this.updateStatistics();
      } finally {
        this.loading = false;
      }
    },

    updateStatistics() {
      if (this.assistant_teacher_reports.length > 0) {
        const total = this.assistant_teacher_reports.length;

        let data = this.assistant_teacher_reports;
        let passed = 0;
        let inProgress = 0;
        data.forEach(value => {
          if (value.pt_licence_ict == "ict") {
            passed += 1;
          } else {
            inProgress += 1;
          }
        });

        const notStarted = this.assistant_teacher_reports.filter(
          item => item.assistant_teacher_re_status == "CC"
        ).length;

        this.statisticsCards[0].value = total;
        this.statisticsCards[1].value = passed;
        this.statisticsCards[2].value = inProgress;
        this.statisticsCards[3].value = notStarted;
      }
    },

    getPersonnelTypeColor(type) {
      switch (type) {
        case "local_dev":
          return "info";
        case "transfer_position":
          return "warning";
        default:
          return "success";
      }
    },

    getPersonnelTypeText(type) {
      switch (type) {
        case "local_dev":
          return "ครูพัฒนาท้องถิ่น";
        case "transfer_position":
          return "ครูโอนย้าย";
        default:
          return "ปกติ";
      }
    },

    getEvaluationStatusColor(item) {
      if (item.report_id_card === item.id_card) return "green";
      if (["1", "2", "3", "4"].includes(item.last_time_ass)) return "info";
      return "red";
    },

    getEvaluationStatusText(item) {
      if (item.report_id_card === item.id_card) return "ส่งผลการประเมิน";
      if (["1", "2", "3", "4"].includes(item.last_time_ass))
        return `ครั้งที่ ${item.last_time_ass}`;
      return "ไม่ได้เริ่มประเมิน";
    },
    async assistant_teacher_reportSubmit() {
      let textAlert = this.assistant_teacher_report_id_card.frist_names;
      Swal.fire({
        title: "ต้องการยกเลิกรายการนี้",
        text: textAlert,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b3151b",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      }).then(async result => {
        if (result.isConfirmed) {
          this.assistant_teacher_report_id_card.ApiKey = this.ApiKey;
          let result = await this.$http.post(
            "assistant_teacher_report.delete.php",
            this.assistant_teacher_report_id_card
          );
          if (result.data.status == true) {
            Swal.fire({
              icon: "success",
              title: "ดำเนินการเรียบร้อย",
              showConfirmButton: false,
              timer: 1500
            });
          } else {
            Swal.fire({
              icon: "warning",
              title: "ดำเนินการผิดพลาด",
              showConfirmButton: false,
              timer: 1500
            });
          }
        }
      });
    },
    async cancel_LicensefiledialogSubmit() {
      if (this.$refs.cancel_Licensefiledialogform.validate()) {
        let textAlert =
          this.editmanage_assistant_teacher.mt_title_s +
          this.editmanage_assistant_teacher.mt_frist_name +
          " " +
          this.editmanage_assistant_teacher.mt_last_name;
        Swal.fire({
          title: "การตรวจสอบ",
          text: textAlert,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#b3151b",
          cancelButtonColor: "#d33",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก"
        }).then(async result => {
          if (result.isConfirmed) {
            this.editmanage_assistant_teacher.ApiKey = this.ApiKey;
            if (
              this.editmanage_assistant_teacher.pt_licence_file_ipa ==
              "dontpass"
            ) {
              let result_del = await this.$http.post("deletefile.php", {
                ApiKey: this.ApiKey,
                filename:
                  "../HRvecLicenseTeach/" +
                  this.editmanage_assistant_teacher.pt_licence_file
              });

              this.editmanage_assistant_teacher.pt_licence_file = "";
            }

            let result = await this.$http.post(
              "manage_assistant_teacher.update.php",
              this.editmanage_assistant_teacher
            );

            if (result.data.status == true) {
              this.manage_assistant_teacher = result.data;
              Swal.fire({
                icon: "success",
                title: "ดำเนินการแก้ไขข้อมูลเรียบร้อย",
                showConfirmButton: false,
                timer: 1500
              });

              await this.checkappoint();
            } else {
              Swal.fire({
                icon: "warning",
                title: "ดำเนินการผิดพลาด",
                showConfirmButton: false,
                timer: 1500
              });
            }
          }
        });
        this.cancel_Licensefiledialog = false;
      }
    },

    async userQueryID() {
      let result;
      let userSession = JSON.parse(localStorage.getItem("user")) || 0;
      result = await this.$http.post("user.php", {
        ApiKey: this.ApiKey,
        user_ID: userSession.user_ID
      });
      this.user_id = result.data;
    },

    async userLogin(user_name, user_password) {
      let result = await this.$http.post("login.php?crud=admin", {
        user_name: user_name,
        user_password: user_password
      });
      if (result.data.user_status) {
        let user = result.data;
        user.system_lock = false;
        localStorage.setItem("user", JSON.stringify(user));
        if (user.user_status == "A") {
          localStorage.setItem("user", JSON.stringify(user));
          this.$router.push("/admin");
        }
        //administrator IPA2
        else if (user.user_status == "B") {
          localStorage.setItem("user", JSON.stringify(user));
          this.$router.push("/college");
        } //college
        else if (user.user_status == "C") this.$router.push("/iven");
        else if (user.user_status == "S") this.$router.push("/supervisions");
        //Vocational Education Institution
        else if (user.user_status == "D") this.$router.push("/personnel");
        //College personnel
        else if (user.user_status == "G") {
          localStorage.setItem("user", JSON.stringify(user));
          this.$router.push("/vecprovince");
        }
        //Vocation College Province
        else {
          localStorage.clear();
          this.dialog = true;
          this.dialog_msg = "ชื่อผู้ใช้ หรือรหัสผ่าน ไม่ถูกต้อง";
        }
      }
    },

    async updateLicense(mt_id) {
      this.editmanage_assistant_teacher = [];
      let result = await this.$http.post("manage_assistant_teacher.php", {
        ApiKey: this.ApiKey,
        mt_id: mt_id
      });
      this.editmanage_assistant_teacher = result.data;
      this.cancel_Licensefiledialog = true;
    },

    async viewFileleavegurantee(assistant_teacher_re_leaveguarantee) {
      this.assistant_teacher_re_leaveguarantee = assistant_teacher_re_leaveguarantee;
      this.assistant_teacher_re_leaveguaranteedialog = true;
    },
    async ccSearch() {
      this.loading = true;
      let result = await this.$http
        .post("manage_assistant_teacher.php", {
          ApiKey: this.ApiKey,
          assistant_teacher_re_status: "CC"
        })
        .finally(() => (this.loading = false));
      this.assistant_teacher_reports = result.data;
    },
    async viewFileScore(param) {
      this.assFileScore = param;
      this.scoredialog = true;
    },
    async viewpdflicenseteach(pt_licence_file) {
      this.pt_licence_files = pt_licence_file;
      let pt_licence_fileCk = String(pt_licence_file);
      if (pt_licence_fileCk.length > 4) {
        this.pdflicenseteachdialog = true;
      } else {
        Swal.fire({
          icon: "warning",
          title: "ไม่ได้แนบไฟล์",
          showConfirmButton: false,
          timer: 1500
        });
      }
    },

    async checkappoint() {
      this.loading = true;
      let mt_appoin_day = this.mt_appoin_day || 0;
      let mt_appoin_month = this.mt_appoin_month || 0;
      let mt_appoin_year = this.mt_appoin_year || 0;
      let dates = new Date(
        mt_appoin_year + "-" + mt_appoin_month + "-" + mt_appoin_day
      );
      let getTime = dates.getTime();
      this.check_param_query = getTime;
      if (getTime > 1) {
        let result = await this.$http
          .post("manage_assistant_teacher.score.php", {
            ApiKey: this.ApiKey,
            mt_appoin_day: mt_appoin_day,
            mt_appoin_month: mt_appoin_month,
            mt_appoin_year: mt_appoin_year,
            mt_type_personnel: this.mt_type_personnel,
            mt_admissions_status: this.mt_admissions_status,
            mt_report_status_4: "ok"
          })
          .finally(() => (this.loading = false));
        this.assistant_teacher_reports = result.data;
        let data = result.data;
        let counts = 0;
        data.forEach(value => {
          if (value.assistant_teacher_re_status == "CC") {
            counts += 1;
          }
        });
        this.check_CC.counts = counts;
      } else {
        let result = await this.$http
          .post("assistant_teacher_report.php", {
            ApiKey: this.ApiKey
          })
          .finally(() => (this.loading = false));
        this.assistant_teacher_reports = result.data;
      }
    },

    async clearSearch() {
      this.assistant_teacher_reports = [];
    },
    async sweetAlertLoading() {
      Swal.fire({
        title: "Please Wait !",
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
        onBeforeOpen: () => {
          Swal.showLoading();
        },
        onAfterClose: () => {
          Swal.hideLoading();
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
    },
    async search_idcard() {
      await this.sweetAlertLoading();
      let result = await this.$http
        .post("assistant_teacher_report.php", {
          ApiKey: this.ApiKey,
          assistant_teacher_re_id_card: this.search
        })
        .finally(() => (this.loading = false));
      this.assistant_teacher_reports = result.data;
      Swal.close();
    },
    async search_name() {
      await this.sweetAlertLoading();
      let result = await this.$http
        .post("assistant_teacher_report.php", {
          ApiKey: this.ApiKey,
          mt_frist_name: this.search
        })
        .finally(() => (this.loading = false));
      this.assistant_teacher_reports = result.data;
      Swal.close();
    },
    async search_lastname() {
      await this.sweetAlertLoading();
      let result = await this.$http
        .post("assistant_teacher_report.php", {
          ApiKey: this.ApiKey,
          mt_last_name: this.search
        })
        .finally(() => (this.loading = false));
      this.assistant_teacher_reports = result.data;
      Swal.close();
    },
    async personnel_temporaryDateApp() {
      await this.sweetAlertLoading();
      let dateTimeApp = this.dateTimeAppSelect.split("-");
      let mt_appoin_day = dateTimeApp[0];
      let mt_appoin_month = dateTimeApp[1];
      let mt_appoin_year = dateTimeApp[2];
      let result = await this.$http
        .post("assistant_teacher_report.php", {
          ApiKey: this.ApiKey,
          mt_appoin_day: mt_appoin_day,
          mt_appoin_month: mt_appoin_month,
          mt_appoin_year: mt_appoin_year
        })
        .finally(() => (this.loading = false));
      this.assistant_teacher_reports = result.data;
      Swal.close();
    },
    async groupDateTimeAppQuery() {
      let result = await this.$http.post("manage_assistant_teacher.php", {
        ApiKey: this.ApiKey,
        calendar_admin: "Ok"
      });
      this.groupDateTimeApps = result.data;
    },
    async pertem_assistantFileCCSubmit() {
      this.Updateassistant_teacher_report.ApiKey = this.ApiKey;
      this.Updateassistant_teacher_report.id_card = this.editassistant_teacher_report.id_card;
      this.Updateassistant_teacher_report.pertem_assistantFileCC = "";
      let resultPic = await this.$http.post("deletefile.php", {
        ApiKey: this.ApiKey,
        filename:
          "../HRvecfiles/" +
          this.editassistant_teacher_report.pertem_assistantFile
      });
      this.Updateassistant_teacher_report.assistant_teacher_report_pic = "";
      let result = await this.$http.post(
        "assistant_teacher_report.update.php",
        this.Updateassistant_teacher_report
      );
      if (result.data.status == true && resultPic.data.status == true) {
        Swal.fire({
          icon: "success",
          title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        this.assistant_teacher_reportASCCQueryAll();
      } else {
        Swal.fire({
          icon: "warning",
          title: "ดำเนินการผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
      this.pertem_assistantFileCCdialog = false;
    },
    async pertem_assistantFileCC(mt_id_card) {
      let result = await this.$http.post("assistant_teacher_report.php", {
        ApiKey: this.ApiKey,
        id_card: mt_id_card
      });
      this.editassistant_teacher_report = result.data;
      this.pertem_assistantFileCCdialog = true;
    },
    async cancel_assistant_teacher_report() {
      this.cancel_assistant_teacher_reportdialog = true;
    },
    async evaluate_assistant(mt_id_card) {
      let result = await this.$http.post("assistant_teacher_report.php", {
        ApiKey: this.ApiKey,
        assistant_teacher_re_id_card: mt_id_card
      });
      this.assistant_teacher_report_id_card = result.data;

      let result_assistant = await this.$http.post("assistant_teacher.php", {
        ApiKey: this.ApiKey,
        assistant_teacher_id_card: mt_id_card
      });
      this.assistant_teachers = result_assistant.data;

      this.evaluate_assistantdialog = true;
    },

    async assistant_teacher_selectsearch() {
      this.loading = true;
      let result = await this.$http
        .post("assistant_teacher_report.php", {
          ApiKey: this.ApiKey,
          position_name: "ครูผู้ช่วย",
          last_time_check: this.select_per
        })
        .finally(() => (this.loading = false));
      this.assistant_teacher_reports = result.data;
    },
    async assistant_teacher_success() {
      this.loading = true;
      let result = await this.$http
        .post("assistant_teacher_report.php", {
          ApiKey: this.ApiKey,
          position_name: "ครูผู้ช่วย",
          evalution_succ: "success"
        })
        .finally(() => (this.loading = false));
      this.assistant_teacher_reports = result.data;
    },
    async assistant_teacher_reportASCCQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("assistant_teacher_report.php", {
          ApiKey: this.ApiKey,
          position_name: "ครูผู้ช่วย",
          pertem_assistantFileCC: "CC"
        })
        .finally(() => (this.loading = false));
      this.assistant_teacher_reports = result.data;
    },
    async assistant_teacher_not_evalution() {
      this.loading = true;
      let result = await this.$http
        .post("assistant_teacher_report.php", {
          ApiKey: this.ApiKey,
          position_name: "ครูผู้ช่วย",
          not_evalution: "check"
        })
        .finally(() => (this.loading = false));
      this.assistant_teacher_reports = result.data;
    },
    async assistant_teacher_add() {
      this.addassistant_teacher = {};
      this.assistant_teacherdialog = true;
    },
    async assistant_teacherEdit(assistant_teacher_id) {
      let result_assistant = await this.$http.post("assistant_teacher.php", {
        ApiKey: this.ApiKey,
        assistant_teacher_id: assistant_teacher_id
      });
      this.assistant_teachers_edit = result_assistant.data;
      this.assistant_teacherEditdialog = true;
    },

    async assistant_teacher_reportCollegeQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("assistant_teacher_report.php", {
          ApiKey: this.ApiKey,
          assistant_teacher_re_college_code: this.college_select
        })
        .finally(() => (this.loading = false));
      this.assistant_teacher_reports = result.data;
    },
    async assistant_teacherdialogSubmit() {
      if (this.$refs.assistant_teacherdialogform.validate()) {
        this.addassistant_teacher.ApiKey = this.ApiKey;
        this.addassistant_teacher.assistant_teacher_college_code = this.assistant_teacher_report_id_card.college_code;
        this.addassistant_teacher.assistant_teacher_id_card = this.assistant_teacher_report_id_card.assistant_teacher_re_id_card;
        this.addassistant_teacher.assistant_teacher_times = this.times_s;

        let result = await this.$http.post(
          "assistant_teacher.insert.php",
          this.addassistant_teacher
        );
        if (result.data.status == true) {
          let result = await this.$http.post("assistant_teacher_report.php", {
            ApiKey: this.ApiKey,
            id_card: this.assistant_teacher_report_id_card
              .assistant_teacher_re_id_card
          });
          this.assistant_teacher_report_id_card = result.data;
          let result_assistant = await this.$http.post(
            "assistant_teacher.php",
            {
              ApiKey: this.ApiKey,
              assistant_teacher_id_card: this.assistant_teacher_report_id_card
                .id_card
            }
          );
          this.assistant_teachers = result_assistant.data;
          Swal.fire({
            icon: "success",
            title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          let userSession = JSON.parse(localStorage.getItem("user")) || 0;
          this.data_syslog.ApiKey = this.ApiKey;
          this.data_syslog.user_account = userSession.user_name;
          this.data_syslog.event_log = "update";
          this.data_syslog.page_log = "assistant_teacher";
          this.data_syslog.table_log = "assistant_teacher";
          this.data_syslog.detail_log = this.addassistant_teacher.assistant_teacher_id_card;
          this.data_syslog.date_times = this.date_today_log;
          await this.$http.post("data_syslog.insert.php", this.data_syslog);
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.assistant_teacherdialog = false;
      }
    },
    async assistant_teacherEditdialogSubmit() {
      if (this.$refs.assistant_teacherEditform.validate()) {
        this.assistant_teachers_edit.ApiKey = this.ApiKey;

        let result = await this.$http.post(
          "assistant_teacher.update.php",
          this.assistant_teachers_edit
        );
        if (result.data.status == true) {
          let result = await this.$http.post("assistant_teacher_report.php", {
            ApiKey: this.ApiKey,
            id_card: this.assistant_teacher_report_id_card
              .assistant_teacher_re_id_card
          });
          this.assistant_teacher_report_id_card = result.data;
          let result_assistant = await this.$http.post(
            "assistant_teacher.php",
            {
              ApiKey: this.ApiKey,
              assistant_teacher_id_card: this.assistant_teacher_report_id_card
                .id_card
            }
          );
          this.assistant_teachers = result_assistant.data;
          Swal.fire({
            icon: "success",
            title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          let userSession = JSON.parse(localStorage.getItem("user")) || 0;
          this.data_syslog.ApiKey = this.ApiKey;
          this.data_syslog.user_account = userSession.user_name;
          this.data_syslog.event_log = "update";
          this.data_syslog.page_log = "assistant_teacher";
          this.data_syslog.table_log = "assistant_teacher";
          this.data_syslog.detail_log = this.assistant_teachers_edit.assistant_teacher_id_card;
          this.data_syslog.date_times = this.date_today_log;
          await this.$http.post("data_syslog.insert.php", this.data_syslog);
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.assistant_teacherEditdialog = false;
      }
    },
    async evaluate_assistantSubmit() {
      this.assistant_teacherConfirmdialog = true;
    },
    async assistant_teacherConfirmdialogSubmit() {
      this.assistant_teachers_confrim.ApiKey = this.ApiKey;
      this.assistant_teachers_confrim.assistant_teacher_id_card = this.assistant_teacher_report_id_card.assistant_teacher_re_id_card;
      this.assistant_teachers_confrim.assistant_teacher_status = "confirm";
      this.assistant_teacher_report_s.ApiKey = this.ApiKey;
      this.assistant_teacher_report_s.assistant_teacher_re_college_code = this.assistant_teacher_report_id_card.college_code;
      this.assistant_teacher_report_s.assistant_teacher_re_id_card = this.assistant_teacher_report_id_card.assistant_teacher_re_id_card;
      this.assistant_teacher_report_s.assistant_teacher_re_datetime = this.date_today;
      this.assistant_teacher_report_s.assistant_teacher_re_avg_score = this.assistant_teacher_report_id_card.avg_score;

      let result = await this.$http.post(
        "assistant_teacher.update.confirm.php",
        this.assistant_teachers_confrim
      );
      let result_assistant_teacher_report = await this.$http.post(
        "assistant_teacher_report.insert.php",
        this.assistant_teacher_report_s
      );
      if (
        result.data.status == true &&
        result_assistant_teacher_report.data.status == true
      ) {
        let result = await this.$http.post("assistant_teacher_report.php", {
          ApiKey: this.ApiKey,
          id_card: this.assistant_teacher_report_id_card
            .assistant_teacher_re_id_card
        });
        this.assistant_teacher_report_id_card = result.data;
        let result_assistant = await this.$http.post("assistant_teacher.php", {
          ApiKey: this.ApiKey,
          assistant_teacher_id_card: this.assistant_teacher_report_id_card
            .id_card
        });
        let result_assistant_teacher_report = await this.$http.post(
          "assistant_teacher_report.php",
          {
            ApiKey: this.ApiKey,
            assistant_teacher_re_id_card: this.assistant_teacher_report_id_card
              .id_card
          }
        );
        this.result_assistant_teacher_reports =
          result_assistant_teacher_report.data;
        let userSession = JSON.parse(localStorage.getItem("user")) || 0;
        this.data_syslog.ApiKey = this.ApiKey;
        this.data_syslog.user_account = userSession.user_name;
        this.data_syslog.event_log = "insert";
        this.data_syslog.page_log = "assistant_teacher_report";
        this.data_syslog.table_log = "assistant_teacher_report";
        this.data_syslog.detail_log = this.assistant_teacher_report_s.assistant_teacher_re_id_card;
        this.data_syslog.date_times = this.date_today_log;
        await this.$http.post("data_syslog.insert.php", this.data_syslog);
        this.assistant_teachers = result_assistant.data;
        Swal.fire({
          icon: "success",
          title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
      } else {
        Swal.fire({
          icon: "warning",
          title: "ดำเนินการผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
      this.assistant_teacherConfirmdialog = false;
    },
    async assistant_teacher_reportEdit(id_rc) {
      let result = await this.$http.post("assistant_teacher_report.php", {
        ApiKey: this.ApiKey,
        id_rc: id_rc
      });
      this.editassistant_teacher_report = result.data;
      this.editassistant_teacher_report.p_word = "";
      this.editassistant_teacher_reportdialog = true;
    },
    async editassistant_teacher_reportSubmit() {
      if (this.$refs.editassistant_teacher_reportform.validate()) {
        this.editassistant_teacher_report.ApiKey = this.ApiKey;
        if (this.editassistant_teacher_report.p_word == "")
          delete this.editassistant_teacher_report.p_word;
        this.editassistant_teacher_report.brith_day = this.brith_day;
        this.editassistant_teacher_report.brith_month = this.brith_month;
        this.editassistant_teacher_report.brith_year = this.brith_year;
        this.editassistant_teacher_report.mt_appoin_day = this.mt_appoin_day;
        this.editassistant_teacher_report.mt_appoin_month = this.mt_appoin_month;
        this.editassistant_teacher_report.mt_appoin_year = this.mt_appoin_year;
        this.editassistant_teacher_report.retrire_year = this.retrire_year;
        let result = await this.$http.post(
          "assistant_teacher_report.update.admin.php",
          this.editassistant_teacher_report
        );
        if (result.data.status == true) {
          this.assistant_teacher_report = result.data;
          Swal.fire({
            icon: "success",
            title: "ดำเนินการแก้ไขข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          let userSession = JSON.parse(localStorage.getItem("user")) || 0;
          this.data_syslog.ApiKey = this.ApiKey;
          this.data_syslog.user_account = userSession.user_name;
          this.data_syslog.event_log = "update";
          this.data_syslog.page_log = "assistant_teacher";
          this.data_syslog.table_log = "assistant_teacher_report";
          this.data_syslog.detail_log = this.editassistant_teacher_report.id_card;
          this.data_syslog.date_times = this.date_today_log;
          await this.$http.post("data_syslog.insert.php", this.data_syslog);
          this.assistant_teacher_reportQueryAll();
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.editassistant_teacher_reportdialog = false;
      }
    },
    async cancel_assistant_teacher_reportdialogSubmit() {
      await this.sweetAlertLoading();
      this.cancel_assistant_teacher_reports.ApiKey = this.ApiKey;
      this.cancel_assistant_teacher_reports.assistant_teacher_re_id_card = this.assistant_teacher_report_id_card.assistant_teacher_re_id_card;
      this.cancel_assistant_teachers.ApiKey = this.ApiKey;
      this.cancel_assistant_teachers.assistant_teacher_id_card = this.assistant_teacher_report_id_card.assistant_teacher_re_id_card;
      this.cancel_assistant_teachers.assistant_teacher_status = "";
      this.cancel_assistant_teachers.assistant_teacher_ipacheck = "NotPass";

      let result = await this.$http.post(
        "assistant_teacher.update.confirm.php",
        this.cancel_assistant_teachers
      );
      let result_assistant_teacher_report = await this.$http.post(
        "assistant_teacher_report.delete.php",
        this.cancel_assistant_teacher_reports
      );
      if (
        result.data.status == true ||
        result_assistant_teacher_report.data.status == true
      ) {
        Swal.fire({
          icon: "success",
          title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        let userSession = JSON.parse(localStorage.getItem("user")) || 0;
        this.data_syslog.ApiKey = this.ApiKey;
        this.data_syslog.user_account = userSession.user_name;
        this.data_syslog.event_log = "Cancel";
        this.data_syslog.page_log = "assistant_teacher";
        this.data_syslog.table_log = "assistant_teacher_report";
        this.data_syslog.detail_log = this.cancel_assistant_teachers.assistant_teacher_id_card;
        this.data_syslog.date_times = this.date_today_log;
        await this.$http.post("data_syslog.insert.php", this.data_syslog);
        Swal.close();
      } else {
        Swal.fire({
          icon: "warning",
          title: "ดำเนินการผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
      this.evaluate_assistantdialog = false;
      this.cancel_assistant_teacher_reportdialog = false;
      await this.checkappoint();
    },

    async sweetAlertLoading() {
      Swal.fire({
        title: "Please Wait !",
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
        onBeforeOpen: () => {
          Swal.showLoading();
        },
        onAfterClose: () => {
          Swal.hideLoading();
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
    }
  },
  watch: {
    assistant_teacher_reports: {
      handler() {
        this.updateStatistics();
      },
      deep: true
    }
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    times_s() {
      let times = this.assistant_teacher_report_id_card.last_time;
      let result;
      if (times == "1") {
        result = 2;
      } else if (times == "2") {
        result = 3;
      } else if (times == "3") {
        result = 4;
      } else if (times == "4") {
        result = "ครบการประเมิน";
      } else {
        result = 1;
      }
      return result;
    },
    date_today() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = today.getFullYear() + 543;
      today = dd + "/" + mm + "/" + yyyy;
      return today;
    },
    color() {
      return "primary";
    },
    date_today_log() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = today.getFullYear() + 543;
      let time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      today = dd + "/" + mm + "/" + yyyy + "/" + time;
      return today;
    },
    mt_appoin_day() {
      return this.$route.query.appoin_day;
    },
    mt_appoin_month() {
      return this.$route.query.appoin_month;
    },
    mt_appoin_year() {
      return this.$route.query.appoin_year;
    },
    mt_admissions_status() {
      return this.$route.query.mt_admissions_status;
    },
    mt_type_personnel() {
      return this.$route.query.mt_type_personnel;
    }
  },
  components: { Assistant_teacher_bar }
};
</script>
<style scoped>
.dashboard-container {
  background: linear-gradient(135deg, #f5f5f5 0%, #90a4ae 100%);
  min-height: 100vh;
}

.dashboard-header {
  background: var(--hv-hero);
  margin-bottom: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.main-content {
  margin-top: -1rem;
}

/* Statistics Cards */
.stat-card {
  border-radius: 16px !important;
  transition: all 0.3s ease;
  border: none !important;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
}

.stat-card-blue {
  background: linear-gradient(135deg, #3B82C4 0%, #2B6CB0 100%);
  color: white;
}

.stat-card-green {
  background: linear-gradient(135deg, #d9777b 0%, #f5576c 100%);
  color: white;
}

.stat-card-orange {
  background: linear-gradient(135deg, #90a4ae 0%, #455a64 100%);
  color: white;
}

.stat-card-red {
  background: linear-gradient(135deg, #2e7d32 0%, #2e7d32 100%);
  color: white;
}

.stat-number {
  color: white !important;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.stat-label {
  color: white !important;
  opacity: 0.9;
}

/* Chart Cards */
.chart-card {
  border-radius: 16px !important;
  background: white;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
  border: none !important;
}

.chart-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-bottom: 1px solid #e9ecef;
  border-radius: 16px 16px 0 0 !important;
}

/* Filter Card */
.filter-card {
  border-radius: 16px !important;
  background: white;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
}

.filter-content {
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px solid #e9ecef !important;
}

.custom-input {
  background: white;
  border-radius: 8px;
}

.custom-input >>> .v-input__control {
  border-radius: 8px;
}

.custom-btn {
  border-radius: 12px !important;
  font-weight: 500;
  text-transform: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.custom-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

/* Alert */
.alert-custom {
  border-radius: 12px !important;
  background: rgba(255, 193, 7, 0.1) !important;
  border-left: 4px solid #A86400 !important;
}

/* Table Card */
.table-card {
  border-radius: 16px !important;
  background: white;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
}

.custom-table {
  border-radius: 0 0 16px 16px;
}

.custom-table >>> .v-data-table__wrapper {
  border-radius: 0 0 16px 16px;
}

.custom-table >>> th {
  background: #f8f9fa !important;
  color: #495057 !important;
  font-weight: 600 !important;
  border-bottom: 2px solid #dee2e6 !important;
}

.custom-table >>> td {
  border-bottom: 1px solid #f1f3f4 !important;
  padding: 12px 16px !important;
}

.custom-table >>> tr:hover {
  background: rgba(25, 118, 210, 0.04) !important;
}

/* Search Section */
.search-section {
  background: #f8f9fa;
  border-radius: 12px 12px 0 0;
  border-bottom: 1px solid #e9ecef;
}

.search-input {
  background: white;
  border-radius: 8px;
}

.search-input >>> .v-input__control {
  border-radius: 8px;
}

.search-options >>> .v-input--radio-group__input {
  justify-content: center;
}

/* Chips */
.chip-custom {
  border-radius: 12px !important;
  font-weight: 500;
  text-transform: none;
}

.score-chip {
  cursor: pointer;
  border-radius: 12px !important;
  font-weight: 600;
  transition: all 0.2s ease;
}

.score-chip:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.3);
}

.evaluation-chip {
  cursor: pointer;
  border-radius: 12px !important;
  font-weight: 500;
  min-width: 120px;
  transition: all 0.2s ease;
}

.evaluation-chip:hover {
  transform: scale(1.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.score-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Cursor */
.cursor-pointer {
  cursor: pointer;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

/* Responsive */
@media (max-width: 960px) {
  .dashboard-header {
    padding: 2rem 1rem;
  }

  .dashboard-header h1 {
    font-size: 1.8rem !important;
  }

  .stat-card {
    margin-bottom: 1rem;
  }

  .filter-content .v-col {
    padding: 8px !important;
  }
}

/* Animation */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.stat-card,
.chart-card,
.filter-card,
.table-card {
  animation: fadeInUp 0.6s ease forwards;
}

.stat-card:nth-child(1) {
  animation-delay: 0.1s;
}
.stat-card:nth-child(2) {
  animation-delay: 0.2s;
}
.stat-card:nth-child(3) {
  animation-delay: 0.3s;
}
.stat-card:nth-child(4) {
  animation-delay: 0.4s;
}
</style>
